export const FILTERS_COOKIE_KEY = "crime_stalker_filters_v1";
export const MARKERS_COOKIE_KEY = "crime_stalker_markers_v1";
export const HIGHLIGHT_COOKIE_KEY = "crime_stalker_highlight_v1";
export const NOTES_STORAGE_KEY = "crime_stalker_notes_v1";
export const NOTES_COOKIE_KEY = "crime_stalker_notes_v1";
export const STALE_TIME = 10 * 60 * 1000;
export const DRAWER_WIDTH_PX = 500;
export const POPUP_REOPEN_DELAY = 200;
export const DEFAULT_MARKER_COLOR = "#1677ff";